import React, { useEffect, useRef, useState } from 'react'
import banner1 from '../../../assets/images/banners/webps/Iveco.webp'
import banner2 from '../../../assets/images/banners/webps/banner1.webp'
import bannerv1 from '../../../assets/images/banners/webps/bannerv1.webp'
import bannerv2 from '../../../assets/images/banners/webps/bannerv2.webp'
import bannerv3 from '../../../assets/images/banners/webps/bannerv3.webp'
import './style.css'
import 'react-image-gallery/styles/css/image-gallery.css'
import ReactImageGallery from 'react-image-gallery';

export default function MainBanner() {
    const gallery = useRef(null);
    const [firstLoad, setFirstLoad] = useState(true);
    const [landscape, setLandscape] = useState(true);

    useEffect(() => {

      if(firstLoad){
        if(window.innerWidth < 850){
          setLandscape(false);
        }
        setFirstLoad(false);
      }

      window.addEventListener("resize", () => {
        if(window.innerWidth < 650 && landscape){
          setLandscape(false);
        }
        if(window.innerWidth > 650 && !landscape){
          setLandscape(true);
        }
      })
    },[firstLoad, landscape])

    const landscapeItems = [
      {
        original: banner1,
        originalAlt: "Iveco Daily con equipo de frío"
      },
      {
        original: banner2,
        originalAlt: "Mercedes Benz Sprinter con diferentes equipos"
      } 
    ]

    const verticalItems = [
      {
        original: bannerv2,
        originalAlt: "Equipo de frio Tecno Ref instalado en Nicolini"
      },
      {
        original: bannerv1,
        originalAlt: "Agrale con Termico y equipo de frio Tecno Ref"
      }, 
      {
        original: bannerv3,
        originalAlt: "Sprinter con furgón termico y equipo de frio"
      } 
    ]

    useEffect(() => {
      //title.current.style.marginLeft = "25px";
    })

  return (
    <div className='MainBanner' ref={gallery}>
      {landscape && <ReactImageGallery items={landscapeItems} useTranslate3D={false} useBrowserFullscreen={false} autoPlay='true'slideInterval={7500} slideDuration={800} showFullscreenButton={false} showPlayButton={false} showBullets={true} showNav={false} />}
      {!landscape && <ReactImageGallery items={verticalItems} useTranslate3D={false} useBrowserFullscreen={false} autoPlay='true'slideInterval={7500} slideDuration={800} showFullscreenButton={false} showPlayButton={false} showBullets={true} showNav={false} />}
    </div>
  )
}
